/**
 * @generated SignedSource<<6f169b08bc3450fff2f4255f43cf9ecd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type DeleteCustomerAccountInput = {
  id: string;
};
export type DeleteCustomerDialogMutation$variables = {
  input: DeleteCustomerAccountInput;
};
export type DeleteCustomerDialogMutation$data = {
  readonly deleteCustomerAccount: {
    readonly id: string;
  } | null | undefined;
};
export type DeleteCustomerDialogMutation = {
  response: DeleteCustomerDialogMutation$data;
  variables: DeleteCustomerDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteCustomerDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteCustomerAccount",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteCustomerDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "IdPayload",
        "kind": "LinkedField",
        "name": "deleteCustomerAccount",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "18d48953a7538283449a5bb8b0fb45aa",
    "id": null,
    "metadata": {},
    "name": "DeleteCustomerDialogMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteCustomerDialogMutation(\n  $input: DeleteCustomerAccountInput!\n) {\n  deleteCustomerAccount(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "310df02666221b051f5f878ec5f81235";

export default node;
